<template>
    <v-dialog v-model="projectApproveDialog" width="90%" max-width="940">
        <v-card component="ProjectVideoDialog">
            <btn class="close" size="icon" color="transparent" :icon="'close'" @click="close" />
            <v-card-text>
                <header>
                    <div class="left">
                        <h2>Video request</h2>
                        <p style="margin: 0">
                            <b>Character: {{ character && character.meno }}</b>
                        </p>
                    </div>
                    <div class="right">
                        <div class="column">
                            <div class="line">
                                <div class="cell label">Created at:</div>
                                <div class="cell value">{{ getDateWithTime(videoRequest.created_at) }}</div>
                            </div>
                            <div class="line">
                                <div class="cell label">Created by:</div>
                                <div class="cell value">
                                    <a :href="getCreatedByEmail ? 'mailto:' + getCreatedByEmail : 'javascript:void(0)'">
                                        {{ getCreatedByEmail }}
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="column">
                            <div class="line">
                                <div class="cell label">Edited at:</div>
                                <div class="cell value">{{ getDateWithTime(videoRequest.updated_at) }}</div>
                            </div>
                            <div class="line">
                                <div class="cell label">Edited by:</div>
                                <div class="cell value">{{ getUpdatedByEmail }}</div>
                            </div>
                        </div>
                    </div>
                </header>

                <v-form ref="form" v-model="formValid" lazy-validation>
                    <v-textarea
                        counter
                        prepend-icon="rule"
                        class="instruction"
                        v-model="videoRequest.instructions"
                        name="instructions"
                        label="Instructions"
                        hint="Instructions for actors."
                        :rules="requiredRule"
                        rows="20"
                    ></v-textarea>
                    <v-textarea
                        counter
                        prepend-icon="textsms"
                        class="script"
                        v-model="videoRequest.script"
                        name="script"
                        label="Script text"
                        hint="Text that will be recorder by actor."
                        :rules="requiredRule"
                        rows="20"
                    ></v-textarea>
                </v-form>
            </v-card-text>
            <v-card-actions class="action">
                <strong class="pt-1 pr-3">Notifications:</strong>
                <v-radio-group v-model="notify" class="mt-0" row hide-details>
                    <v-radio label="All" value="all"></v-radio>
                    <v-radio label="Only new" value="only_unnotified"></v-radio>
                    <v-radio label="None" value="none"></v-radio>
                </v-radio-group>
                <v-col class="buttons">
                    <div class="holder d-flex justify-end" :class="{ confirm: confirm }">
                        <btn color="transparent" :disabled="loading" text="Cancel" @click="close" />
                        <btn
                            class="send"
                            :icon="!isCreated ? 'save' : 'send'"
                            :text="(!isCreated ? 'Create' : 'Update') + ' video request'"
                            tpos="left"
                            :color="'accent'"
                            @click.prevent="checkValid"
                        />
                        <btn
                            class="confirm"
                            :icon="'check'"
                            :text="'Confirm'"
                            tpos="left"
                            :color="'base'"
                            :state="loading ? 'load' : null"
                            @click.prevent="save"
                        />
                    </div>
                </v-col>
                <div class="message" :class="{ visible: result !== null, error: result === false }">
                    <i class="icon" v-if="result">done_all</i>
                    <i class="icon" v-else>warning</i>
                    <h3>{{ message }}</h3>
                </div>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import moment from 'moment';

const defaultVideoRequest = {
    id: null,
    character_id: null,
    instructions: '',
    script: '',
    created_at: null,
    createdBy: {},
    updated_at: null,
    updatedBy: {},
};

export default {
    name: 'ProjectVideoDialog',

    // !!! Sem sa pisu komponenty
    // components: {},

    data() {
        return {
            character: null,
            loading: false,
            confirm: false,
            message: '',
            result: null,
            formValid: true,
            requiredRule: [(v) => !!v || 'This field is required'],
            videoRequest: { ...defaultVideoRequest },
            notify: 'all',
        };
    },

    methods: {
        ...mapActions(['requestProjectVideo', 'loadVideoRequestDetail']),
        ...mapMutations(['setProjectVideoDialog']),

        close() {
            if (this.confirm) {
                this.confirm = false;
                return;
            }
            this.setProjectVideoDialog({ visible: false, character: null });
            this.reset();
        },

        reset() {
            this.loading = false;
            this.confirm = false;
            this.message = '';
            this.result = null;
            this.$refs.form.resetValidation();
            this.videoRequest = { ...defaultVideoRequest };
        },

        checkValid() {
            if (!this.$refs.form.validate()) {
                return;
            }
            this.confirm = true;
        },

        async save() {
            this.loading = true;
            try {
                await this.requestProjectVideo({
                    character_id: this.videoRequest.character_id ?? this.character.id,
                    instructions: this.videoRequest.instructions,
                    script: this.videoRequest.script,
                    notify: this.notify != 'none' ? this.notify : null,
                });

                this.result = true;
                this.message = 'Video request was ' + (!this.isCreated ? 'created' : 'updated');
                this.$_eventsDispatch('videoRequestSubmitted');
                setTimeout(() => {
                    this.setProjectVideoDialog({ visible: false, character: null });
                    this.reset();
                }, 2000);
            } catch (e) {
                this.result = false;
                this.message = 'Something went wrong';
                throw e;
            } finally {
                this.confirm = false;
                this.loading = false;
            }
        },

        async loadRequest() {
            this.videoRequest = { ...defaultVideoRequest };
            try {
                const data = await this.loadVideoRequestDetail({
                    character_id: this.character.id,
                    query: { include: ['createdBy', 'updatedBy', 'chracter', 'character.candidates'] },
                });
                if (data) {
                    this.videoRequest = data;
                }
            } catch (e) {
                this.$emit('error', e);
                this.$bugsnag.notify(e);
            }
        },
    },

    computed: {
        ...mapGetters(['getProjectVideoDialog', 'getUser']),

        isCreated() {
            return this.videoRequest.id != null;
        },

        projectApproveDialog: {
            get: function () {
                this.character = this.getProjectVideoDialog.character;
                return this.getProjectVideoDialog.visible;
            },
            set: function (val) {
                this.setProjectVideoDialog({ visible: val, character: this.character });
            },
        },

        getDateWithTime() {
            return (date) => {
                if (!date) return '';
                const day = date.split('T')[0];
                const hours = date.split('T')[1].split('.')[0];
                const newDate = day + ' ' + hours;
                return `${moment(newDate).format('DD. MM. YYYY')} at ${moment(newDate).format('HH:mm')}`;
            };
        },

        getCreatedByEmail() {
            return this.videoRequest?.createdBy?.email ?? '';
        },

        getUpdatedByEmail() {
            return this.videoRequest?.updatedBy?.email ?? '';
        },
    },

    watch: {
        projectApproveDialog(val) {
            if (val) {
                this.loadRequest();
            }
        },
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='ProjectVideoDialog'] {
    display: flex;
    flex-direction: column;

    header {
        display: flex;
        padding: 20px 0 10px;
        border-bottom: 1px solid @border;
        margin-bottom: 10px;

        .left {
            width: 30%;
            h2 {
                font-size: 20px;
                font-weight: 500;
            }
        }

        .right {
            width: 70%;
            display: flex;
            justify-content: space-between;
            .column {
                padding: 0 20px;

                .line {
                    display: flex;
                    flex-wrap: wrap;

                    .label {
                        min-width: 77px;
                        white-space: nowrap;
                    }

                    .value {
                        min-width: 120px;
                    }
                }
            }
        }
    }

    .close {
        position: absolute;
        top: 0;
        right: 0;
        margin: 0;
    }

    form {
        .instruction {
            margin-right: 30px;
        }
    }

    .action {
        position: relative;
        overflow: hidden;
        width: 100%;
        .flex-row;
        justify-content: flex-end;
        margin-top: 30px;

        .buttons {
            .flex-row;
        }

        .holder {
            position: relative;
            transition: 0.3s;
            width: 100%;

            &.confirm {
                // width: 110px;

                .send {
                    transform: translateX(130%);
                    transition-delay: 0s;
                }

                .confirm {
                    transition-delay: 0.3s;
                    transform: translateY(0);
                }
            }

            button {
                transition: 0.3s;

                &.send {
                    transition-delay: 0.3s;
                }

                &.confirm {
                    position: absolute;
                    top: 0;
                    right: 0;
                    z-index: 4;
                    transform: translateX(130%);
                    transition-delay: 0.3s;
                }
            }
        }
    }

    .message {
        position: absolute;
        left: 0;
        bottom: 0;
        background: white;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 5;
        color: @base;
        transition: 0.3s;
        transition-delay: 0.3s;
        transform: translateY(100%);

        &.error {
            color: @accent;

            h3 {
                color: @accent;
            }
        }

        &.visible {
            transition-delay: 0s;
            transform: translateY(0);
        }

        h3 {
            color: @base;
            margin: 0 0 0 5px;
        }
    }
}
</style>
